import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroCarousel from './components/HeroCarousel';
import AboutSection from './components/AboutSection';
import CollectionsSection from './components/CollectionsSection';
import FounderSection from './components/FounderSection';
import InstagramCTA from './components/InstagramCTA';
import SocialProofSection from './components/SocialProofSection';
import NewsletterSection from './components/NewsletterSection';
import { Toaster } from './components/ui/toaster';
import { heroSlides, collections } from './mock';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroCarousel slides={heroSlides} />
        <AboutSection />
        <InstagramCTA />
        <CollectionsSection collections={collections} />
        <FounderSection />
        <SocialProofSection />
        <NewsletterSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;